import { useAnswerByGuestSession } from '../../shared/hooks/useAnswerByGuestSession';
import { useAttendanceState } from './useAttendanceState';

export const useRegistrationPreviousResponse = (formId: string, eventId: string) => {
  const { loading: answersLoading, answers, guestKey } = useAnswerByGuestSession(formId, eventId ?? '');
  const { attendanceState, loading: attendanceLoading, contact } = useAttendanceState(eventId ?? '', guestKey ?? '');

  const loading = answersLoading || attendanceLoading;

  return { loading, answers, contact, guestKey: guestKey ?? undefined, attendanceState };
};
